import EcoSection from 'eco-design/base/eco-section';
import EcoGraphicItems from 'eco-design/sections/eco-graphic-items';

import getLocal from '@/app/utils/getLocal';
import { useGlobal } from '@/utils/useGlobal';
import { FC } from 'react';
import MinTitle from '../MinTitle';
import styled from './index.module.scss';
import { isStatusC } from '../../utils';

interface PlugProps {
    pageType: string;
}
const euPages = ['normal', 'ultra', 'ac'];

const PlugCommon: FC<PlugProps> = ({ pageType = 'normal' }) => {
    const { locale } = getLocal();
    const { useLang, useState, gtm, isMobile } = useGlobal();

    const { t } = useLang('theProduct.Plug');

    const statusC = isStatusC();

    let min_title = t('min_title');
    if (pageType === 'normal') {
        min_title = t('normal_min_title') || t('min_title');
    }
    const pageTypeObj: any = {
        normal: {
            title: t('title'),
            subTitle: t('subTitle'),
            items: [
                {
                    desc: t('item1_desc'),
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1745314638975/Frame%201612690062.png',
                    title: t('item1_title'),
                },
                {
                    desc: t('item2_desc'),
                    pc: statusC
                        ? 'https://websiteoss.ecoflow.com/upload/image/1748655869970/Vertical%20Design%20(1).jpg'
                        : 'https://websiteoss.ecoflow.com/upload/image/1745314661702/Frame%201612690061.png',
                    title: t('item2_title'),
                },
            ],
        },
        ultra: {
            title: t('ultra_title'),
            subTitle: t('ultra_subTitle'),
            items: [
                {
                    desc: t('ultra_item1_desc'),
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1745314638975/Frame%201612690062.png',
                    title: t('ultra_item1_title'),
                },
                {
                    desc: t('ultra_item2_desc'),
                    pc: statusC
                        ? 'https://websiteoss.ecoflow.com/upload/image/1748655869970/Vertical%20Design%20(1).jpg'
                        : 'https://websiteoss.ecoflow.com/upload/image/1745314661702/Frame%201612690061.png',
                    title: t('ultra_item2_title'),
                },
            ],
        },
        ac: {
            title: t('ac_title'),
            subTitle: t('ac_subTitle'),
            items: [
                {
                    desc: t('ac_item1_desc'),
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1745314638975/Frame%201612690062.png',
                    title: t('ac_item1_title'),
                },
                {
                    desc: t('ac_item2_desc'),
                    pc: statusC
                        ? 'https://websiteoss.ecoflow.com/upload/image/1748655869970/Vertical%20Design%20(1).jpg'
                        : 'https://websiteoss.ecoflow.com/upload/image/1745314661702/Frame%201612690061.png',
                    title: t('ac_item2_title'),
                },
            ],
        },
        na: {
            title: t('title'),
            subTitle: t('subTitle'),
            items: [
                {
                    desc: t('item1_desc'),
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1744957264166/Frame%201612690062.jpg',
                    title: t('item1_title'),
                },
                {
                    desc: t('item2_desc'),
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1744957263982/Frame%201612690061.jpg',
                    title: t('item2_title'),
                },
            ],
        },
    };
    const objectA = pageTypeObj[pageType] || pageTypeObj['normal'];
    const itemsA = objectA.items || [];
    return (
        <section className={`${styled.Plug} ${styled[`Plug_${pageType}`]}`} id="Plug">
            <div className={`plug-container ${pageType}`}>
                {!statusC && euPages.includes(pageType) && <MinTitle title={min_title} align="center" />}
                <EcoSection
                    className="plug-box-title product-section"
                    subTitle={statusC ? '' : objectA.subTitle}
                    title={objectA.title}
                    subTitleColor="#696C71"
                />
                <EcoGraphicItems className="plug-graphic" items={itemsA} />
            </div>
        </section>
    );
};

export default PlugCommon;
